import React, { Component } from "react";
import ProfileCard from "../../Components/Home/ProfileCard";
import HomeCard from "../../Components/Home/HomeCard";
import Header from "../../Components/MainLayout/Header";
import { connect } from "react-redux";
import AttendanceIcon from "../../Assets/img/edit-property.png";
import GalleryIcon from "../../Assets/img/stack-of-photos.png";
import ComplaintIcon from "../../Assets/img/box-important.png";
import EventIcon from "../../Assets/img/planner.png";
import HolidayIcon from "../../Assets/img/beach-umbrella.png";
import NotificationIcon from "../../Assets/img/appointment-reminders.png";
import BirthdayIcon from "../../Assets/img/birthday-icon.png";
import Axios from "axios";
import Cover from "../../Assets/img/default-cover-image.svg";
import Authorize from "../../../global/Authorize";
import Visible from "../../../global/Visible";
import download from "../../Assets/img/download.png";
import Skeleton from "react-loading-skeleton";
import OnlineClassIcon from "../../Assets/img/video-conference.png";
// import Lclass from "../../Assets/img/LiveClass.png";
import dashboardImg from "../../Assets/img/stat.png";
import HomeWorkIcon from "../../Assets/img/home-page.png";
import feeStat from "../../Assets/img/feeStat.png";

// import schedule from "../../Assets/img/schedule.png";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class THome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      UpcomingEventData: [],
      loading: true,
      fakeData: [1, 2, 3],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Home";

    var dt = new Date();

    this.fetchUpcomingEventData({
      session: this.props?.user?.session?.id,
    });
    this.fetchAssignedClassSubject({
      school: this.props.user.user.school.id,
      user__username: this.props.user.user?.username,
    });
  }

  fetchAssignedClassSubject = (params = {}) => {
    Axios.get(`/api/staff`, {
      params: { ...params },
      type: "json",
    }).then((res) => {
      localStorage.setItem(
        "assignedClassSubject",
        res.data.results?.length > 0 ? JSON.stringify(res.data.results[0]) : []
      );
    });
  };
  fetchUpcomingEventData = (params = {}) => {
    Axios.get("/mApiV1/EventsList", { params: { ...params } })
      .then((res) => {
        this.setState({ UpcomingEventData: res.data, loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };

  render() {
    const handelDt = (dt) => {
      var j = dt % 10,
        k = dt % 100;
      if (j === 1 && k !== 11) {
        return dt + "st";
      }
      if (j === 2 && k !== 12) {
        return dt + "nd";
      }
      if (j === 3 && k !== 13) {
        return dt + "rd";
      }
      return dt + "th";
    };
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    const handleDate = (date1, date2) => {
      let year1 = new Date(date1).getFullYear();
      let month1 = new Date(date1).getMonth();
      let dt1 = new Date(date1).getDate();

      let year2 = new Date(date2).getFullYear();
      let month2 = new Date(date2).getMonth();
      let dt2 = new Date(date2).getDate();

      year1 = year1 % 100;
      year2 = year2 % 100;
      if (year1 === year2) {
        if (month1 === month2) {
          if (dt1 === dt2) {
            return `${handelDt(dt1)} ${monthNames[month1]}, ${year1}`;
          } else {
            return `${handelDt(dt1)}-${handelDt(dt2)} ${
              monthNames[month1]
            }, ${year1}`;
          }
        } else {
          return `${handelDt(dt1)} ${monthNames[month1]} - ${handelDt(dt2)} ${
            monthNames[month2]
          }, ${year1}`;
        }
      } else {
        return `${handelDt(dt1)} ${monthNames[month1]}  ${year1} - ${handelDt(
          dt2
        )} ${monthNames[month2]}, ${year2}`;
      }
    };

    return (
      <Authorize
        roles={["IS_TEACHER", "IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}
        redirect
        to="/login"
      >
        <Header title="Home" />

        <ProfileCard />

        {this.state?.UpcomingEventData ? (
          <>
            <div className="container">
              {this.state?.UpcomingEventData?.length !== 0 &&
              this.state.loading === false ? (
                <h5 className="th-16">Upcoming Events</h5>
              ) : null}
            </div>
            <div
              className="d-flex flex-row th-no-scroll"
              style={{ overflowX: "scroll" }}
            >
              {this.state.loading ? (
                <>
                  {this.state.fakeData?.map((item, index) => (
                    <div key={index}>
                      <Skeleton
                        className="ml-3 overflow-hidden"
                        height={180}
                        width={240}
                      />
                    </div>
                  ))}
                  <div className="px-2"></div>
                </>
              ) : (
                <>
                  {this.state.UpcomingEventData?.map((item, index) => (
                    <div key={index}>
                      <div
                        className="ml-3 overflow-hidden"
                        style={{
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          backgroundPosition: "center",

                          backgroundImage: `url(${
                            item?.event_image ? item?.event_image : Cover
                          })`,

                          // backgroundImage: `url(${item.event_image})`,
                          borderRadius: 16,
                        }}
                      >
                        <div
                          className="d-flex align-items-end"
                          style={{
                            height: 180,
                            minWidth: 240,
                            width: 240,
                            padding: 16,
                            background:
                              "linear-gradient(360deg, rgba(0, 0, 0, 0.81) 0%, rgba(0, 0, 0, 0.400781) 31.77%, rgba(0, 0, 0, 0) 100%)",
                          }}
                        >
                          <div className="">
                            <h6
                              className="th-14 mb-0 text-white"
                              style={{ width: 180 }}
                            >
                              {item?.event_name}
                            </h6>
                            <p
                              className="th-12 text-truncate mb-0 text-light"
                              style={{ width: 208 }}
                            >
                              {handleDate(item?.from_date, item?.to_date)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className="px-2"></div>
                </>
              )}
            </div>
          </>
        ) : null}

        <div className="container py-4">
          <h5 className="th-16">Explore</h5>
          <div className="row px-2">
            <div className="col-4 px-2">
              <HomeCard title="Gallery" to="/gallery" iconImage={GalleryIcon} />
            </div>
            <Visible roles={["IS_TEACHER", "IS_PRINCIPAL"]}>
              <div className="col-4 px-2">
                <HomeCard
                  title="Student Attendance"
                  to="/attendance"
                  iconImage={AttendanceIcon}
                />
              </div>
            </Visible>
            <div className="col-4 px-2">
              <HomeCard title="Events" to="/events" iconImage={EventIcon} />
            </div>
            <div className="col-4 px-2">
              <HomeCard
                title="Holidays"
                to="/holidays"
                iconImage={HolidayIcon}
              />
            </div>
            <div className="col-4 px-2">
              <HomeCard
                title="Notifications"
                to="/tnotifications"
                iconImage={NotificationIcon}
              />
            </div>
            <Visible roles={["IS_TEACHER"]}>
              <div className="col-4 px-2">
                <HomeCard
                  title="Complaints"
                  to="/prevComplaint"
                  iconImage={ComplaintIcon}
                />
              </div>
            </Visible>
            <Visible roles={["IS_TEACHER"]}>
              <div className="col-4 px-2">
                <HomeCard
                  title="My Attendance"
                  to="/attStaff"
                  iconImage={AttendanceIcon}
                />
              </div>
            </Visible>
            <Visible roles={["IS_TEACHER", "IS_PRINCIPAL"]}>
              <div className="col-4 px-2">
                <HomeCard
                  title="Birthday"
                  to="/birthday"
                  iconImage={BirthdayIcon}
                />
              </div>
            </Visible>
            <Visible
              roles={[
                "IS_TEACHER",
                "IS_ADMIN",
                "IS_SUPERADMIN",
                "IS_PRINCIPAL",
              ]}
            >
              <div className="col-4 px-2">
                <HomeCard
                  title="Online Class"
                  to="/onlineclass"
                  iconImage={OnlineClassIcon}
                />
              </div>
            </Visible>
            {/*<Visible roles={["IS_TEACHER"]}>
              <div className="col-4 px-2">
                <HomeCard
                  title="Add Marks"
                  to="/addmarks"
                  iconImage={results}
                />
              </div>
                        </Visible>*/}
            <Visible roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
              <div className="col-4 px-2">
                <HomeCard
                  title="All Complaints"
                  to="/allComplaint"
                  iconImage={ComplaintIcon}
                />
              </div>
            </Visible>
            <Visible roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
              <div className="col-4 px-2">
                <HomeCard
                  title="Downloads"
                  to="/downloads"
                  iconImage={download}
                />
              </div>
            </Visible>
            <Visible roles={["IS_ADMIN", "IS_SUPERADMIN"]}>
              <div className="col-4 px-2">
                <HomeCard
                  title="Dashboard"
                  to="/maindashboard"
                  iconImage={dashboardImg}
                />
              </div>
            </Visible>
            <Visible roles={["IS_ADMIN", "IS_SUPERADMIN"]}>
              <div className="col-4 px-2">
                <HomeCard
                  title="Fee Statistics"
                  to="/termWiseFee"
                  iconImage={feeStat}
                />
              </div>
            </Visible>
            <Visible roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
              <div className="col-4 px-2">
                <HomeCard
                  title="Student Attendance"
                  to="/attSummary"
                  iconImage={AttendanceIcon}
                />
              </div>
            </Visible>
            <Visible roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
              <div className="col-4 px-2">
                <HomeCard
                  title="Group SMS"
                  to="/grpsms"
                  iconImage={AttendanceIcon}
                />
              </div>
            </Visible>
            <Visible roles={["IS_TEACHER", "IS_PRINCIPAL"]}>
              <div className="col-4 px-2">
                <HomeCard
                  title="Home Work"
                  to="/uploadHomework"
                  iconImage={HomeWorkIcon}
                />
              </div>
            </Visible>

            {/* <div className="col-4 px-2">
              <HomeCard
                title="Exam Schedule"
                to="/examSchedule"
                iconImage={schedule}
              />
            </div> */}

            {/* <Visible roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}>
              <div className="col-4 px-2">
                <HomeCard
                  title="Main Dashboard"
                  to="/teacherLiveClass"
                  iconImage={Lclass}
                />
              </div>
            </Visible> */}
            {/* <Visible
              roles={[
                "IS_ADMIN",
                "IS_SUPERADMIN",
                "IS_PRINCIPAL",
                "IS_TEACHER",
              ]}
            >
              <div className="col-4 px-2">
                <HomeCard title="Leave" to="/prevLeave" iconImage={LeaveIcon} />
              </div>
            </Visible> */}
          </div>
        </div>
      </Authorize>
    );
  }
}
export default connect(mapStateToProps)(THome);
